import {
  Wellhead,
  WellheadScheme,
  WellheadSectionName,
  WellheadTopConnectorType,
  WellheadBottomConnectorType,
} from 'src/app/interfaces/wellhead';

export const WELLHEADS: Wellhead[] = [
  {
    handoverId: 165,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: 'gjTkR',
    casingId: 'Ge9oC',
    wellboreNo: 'OH',
    installDate: new Date('2019-07-04T00:00:00'),
    assemblyName: 'SURFACE CASING',
    sectionNameId: 1,
    topHub: 11000,
    topFlange: 3000,
    topConnectorTypeId: 2,
    bottomHub: 9.625,
    bottomFlange: 3000,
    bottomConnectorTypeId: 1,
    flangeManufacturer: 'WENLEN S.A.',
    comments: 'Postman test',
  },
  {
    handoverId: 165,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: 'pMjlc',
    casingId: 'EU5vD',
    wellboreNo: 'OH',
    installDate: new Date('2019-07-25T00:00:00'),
    assemblyName: 'PRODUCTION CASING 1',
    sectionNameId: null,
    topHub: 7.0625,
    topFlange: 3000,
    topConnectorTypeId: 1,
    bottomHub: 11,
    bottomFlange: 3000,
    bottomConnectorTypeId: null,
    flangeManufacturer: 'WENLEN S.A.',
    comments: '',
  },
];

export const WELLHEAD_SECTION_NAMES: WellheadSectionName[] = [
  {
    wellheadSectionNameId: 1,
    wellheadSectionNameName: 'Sección A',
  },
  {
    wellheadSectionNameId: 2,
    wellheadSectionNameName: 'Sección B',
  },
  {
    wellheadSectionNameId: 3,
    wellheadSectionNameName: 'Sección B2',
  },
  {
    wellheadSectionNameId: 4,
    wellheadSectionNameName: 'Sección B3',
  },
  {
    wellheadSectionNameId: 5,
    wellheadSectionNameName: 'Sección C',
  },
  {
    wellheadSectionNameId: 6,
    wellheadSectionNameName: 'Brida adaptadora de producción o fractura',
  },
  {
    wellheadSectionNameId: 7,
    wellheadSectionNameName: 'Carretel Adaptador',
  },
  {
    wellheadSectionNameId: 8,
    wellheadSectionNameName: 'Otro',
  },
];

export const WELLHEAD_TOP_CONNECTOR_TYPES: WellheadTopConnectorType[] = [
  {
    wellheadTopConnectorTypeId: 1,
    wellheadTopConnectorTypeName: 'Bridada',
  },
  {
    wellheadTopConnectorTypeId: 2,
    wellheadTopConnectorTypeName: 'Roscada',
  },
  {
    wellheadTopConnectorTypeId: 3,
    wellheadTopConnectorTypeName: 'Especial',
  },
  {
    wellheadTopConnectorTypeId: 4,
    wellheadTopConnectorTypeName: 'Integral',
  },
];

export const WELLHEAD_BOTTOM_CONNECTOR_TYPES: WellheadBottomConnectorType[] = [
  {
    wellheadBottomConnectorTypeId: 1,
    wellheadBottomConnectorTypeName: 'Soldada',
  },
  {
    wellheadBottomConnectorTypeId: 2,
    wellheadBottomConnectorTypeName: 'Roscada',
  },
  {
    wellheadBottomConnectorTypeId: 3,
    wellheadBottomConnectorTypeName: 'Slip Lock',
  },
  {
    wellheadBottomConnectorTypeId: 4,
    wellheadBottomConnectorTypeName: 'Landing hanger',
  },
  {
    wellheadBottomConnectorTypeId: 5,
    wellheadBottomConnectorTypeName: 'Integral',
  },
  {
    wellheadBottomConnectorTypeId: 6,
    wellheadBottomConnectorTypeName: 'Bridada',
  },
];

export const WELLHEAD_SCHEMES: WellheadScheme[] = [
  {
    wellheadSchemeId: 1,
    handoverId: 1234,
    sectionId: 1,
    workingPressure: 5000,
    testDate: new Date('2026-03-10 00:00:00'),
  },
];
